module.exports = __webpack_public_path__ + "static/img/splash-bottom-sm.c5de0ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/splash-bottom-sm.jpg
// module id = mOv4
// module chunks = 0